import React from "react";
import { CiMenuFries } from "react-icons/ci";
import { IoClose } from "react-icons/io5"

export default function ToggleNav({ isOpen, onToggle }) {
  return (
    <div className="w-[100%] bg-[#6c6356] top-0 left-0 fixed grid grid-cols-2 py-2 px-5 items-center z-50">
      
      <button
        onClick={onToggle}
        className="text-cyan-200 w-fit"
        aria-label="Toggle menu"
      >
        {isOpen ? (
          <IoClose className="text-3xl" />
        ) : (
          <CiMenuFries className="text-3xl" />
        )}
      </button>

      <h1 className="text-xl font-bold text-white">
        Mandla<span className="text-4xl ml-1 text-[#0ff]">.</span>
      </h1>
    </div>
  );
}
